import { render } from "./FilterFungsi.vue?vue&type=template&id=9c9c2c88"
import script from "./FilterFungsi.vue?vue&type=script&lang=js"
export * from "./FilterFungsi.vue?vue&type=script&lang=js"
script.render = render

export default script